// router/navigationGuard.js
import { useCompanyStore } from '../stores/company';

export const navigationGuards = {
  // Verifica se a navegação está vindo de uma origem válida e tem os dados necessários
  validateNavigation(to, from) {
    const companyStore = useCompanyStore();
    
    // Define as rotas válidas e suas dependências
    const validRoutes = {
      'nps-form-slug': ['not-found'], // Pode vir da página 404 ou acesso direto
      'nps-form-custom-link': ['not-found'], // Pode vir da página 404 ou acesso direto
      'IntermediateScreen': ['nps-form-slug', 'nps-form-custom-link'],
      'InternalForm': ['nps-form-slug', 'nps-form-custom-link'],
      'ThankYouPage': ['InternalForm', 'nps-form-slug', 'nps-form-custom-link']
    };

    // Permite acesso direto às rotas iniciais
    if (['nps-form-slug', 'nps-form-custom-link', 'not-found'].includes(to.name)) {
      return true;
    }

    // Para rotas protegidas, verifica se:
    // 1. A rota existe na lista de validação
    // 2. Está vindo de uma origem válida
    // 3. Tem os dados da empresa na store
    if (validRoutes[to.name]) {
      const isValidOrigin = from.name && validRoutes[to.name].includes(from.name);
      const hasCompanyData = companyStore.tempCompany !== null;

      // Se não atender aos requisitos, retorna false
      if (!isValidOrigin || !hasCompanyData) {
        console.log('Navegação inválida:', {
          route: to.name,
          hasValidOrigin: isValidOrigin,
          hasCompanyData: hasCompanyData
        });
        return false;
      }
    }

    return true;
  },

  // Valida os parâmetros específicos de cada rota
  validateRouteParams(to) {
    const companyStore = useCompanyStore();

    switch (to.name) {
      case 'nps-form-slug':
        return /^[a-z2-9]{3}$/.test(to.params.slug);

      case 'nps-form-custom-link':
        return /^[a-zA-Z0-9-_]{3,50}$/.test(to.params.custom_link);

      case 'InternalForm': {
        const nps = Number(to.query.nps);
        const reviewId = to.query.review_id;
        const hasCompanyData = companyStore.tempCompany !== null;
        
        return !isNaN(nps) && 
               nps >= 0 && 
               nps <= 10 && 
               reviewId && 
               hasCompanyData;
      }
      case 'IntermediateScreen': {
        const link = to.query.link;
        const hasValidCompany = companyStore.tempCompany !== null;
        
        return !!link && hasValidCompany;
      }
      case 'ThankYouPage':
        return companyStore.tempCompany !== null;

      default:
        return true;
    }
  },

  // Limpa os dados temporários quando apropriado
  cleanupNavigation(to) {
    const companyStore = useCompanyStore();
    
    // Lista de rotas que devem limpar os dados temporários
    const cleanupRoutes = ['not-found', 'nps-form-slug', 'nps-form-custom-link'];
    
    if (cleanupRoutes.includes(to.name)) {
      companyStore.clearTempCompany();
    }
  }
};